import Group from '@/views/group'
import List from '@/views/group/list'
import Permission from '@/views/group/permission'
import Menu from '@/views/group/menu'
import GroupAlias from '@/views/group-alias'

export default {
  path: 'group',
  component: Group,
  redirect: 'group/list',
  name: 'checklist.attribute.group',
  children: [
    {
      path: 'list',
      name: 'group_user.list',
      component: List
    },
    {
      path: ':group_id/permission',
      name: 'permission.permission',
      component: Permission
    },
    {
      path: ':group_id/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: 'alias',
      name: 'group_user.alias',
      component: GroupAlias
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/groups/group.js